type JobWithDates = {
  dates?: {
    start_recalculated?: number;
    end_recalculated?: number;
  };
};

/**
 * Ongoing jobs (started, no end date) come first ordered by most recent start,
 * then ended jobs ordered by most recent end, then jobs we have no dates for.
 */
export const sortJobsByDates = <T extends JobWithDates>(jobs: T[]): T[] => {
  const ongoingJobs = jobs.filter((job) => job.dates?.start_recalculated && !job.dates.end_recalculated);
  const endedJobs = jobs.filter((job) => job.dates?.end_recalculated);
  const undatedJobs = jobs.filter((job) => !job.dates?.start_recalculated && !job.dates?.end_recalculated);

  const sortedOngoingJobs = ongoingJobs.sort(
    (a, b) => (b.dates?.start_recalculated ?? 0) - (a.dates?.start_recalculated ?? 0),
  );

  const sortedEndedJobs = endedJobs.sort((a, b) => {
    const endDiff = (b.dates?.end_recalculated ?? 0) - (a.dates?.end_recalculated ?? 0);
    if (endDiff !== 0) return endDiff;
    return (b.dates?.start_recalculated ?? 0) - (a.dates?.start_recalculated ?? 0);
  });

  return [...sortedOngoingJobs, ...sortedEndedJobs, ...undatedJobs];
};
